<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada" class="select-modal">
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("prestacao-contas")}}
                                <a
                                    class="pl-1"
                                    v-if="hide.hideInfo"
                                    @click="infoIsHidden()"
                                >
                                    <b-icon
                                        v-if="!hide.infoIsHidden"
                                        icon="eye-off-outline"
                                        type="is-danger"
                                    />
                                    <b-icon
                                        v-if="hide.infoIsHidden"
                                        icon="eye-outline"
                                        type="is-success"
                                    />
                                </a>
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("despesas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                $router.push({
                                                    name: 'des-acerto-despesa-list',
                                                })
                                            "
                                        >
                                            {{ $t("prestacao-contas") }}
                                        </a>
                                    </li>
                                    <li>
                                        <a aria-current="page">
                                            {{ $t("prestacao-contas") }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <!-- BOTÕES -->
                        <div class="header-buttons">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="redirectToPage"
                            >
                                {{ $t("voltar") }}
                            </button>
                            <button
                                @click="buscarModelosRecibo()"
                                class="save-btn"
                                v-if="acertoDespesa != null && [1,2].includes(acertoDespesa.situacao)"
                            >
                                {{ $t("imprimir") }}
                            </button>
                        </div>
                    </div>
                    <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>
                    <!-- CONJTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>

                    <Geral
                        ref="tabGeral"
                        v-show="abas[abaSelecionada] == 'geral'"
                        v-if="!newToEdit && permissao.read"
                        :isUpdate="isUpdate"
                        @isChanged="isChanged = $event"
                        @acertoDespesa="acertoDespesa=$event"
                        @parametrizacao="parametrizacao=$event"
                        @cantEdit="cantEdit=$event"
                        @isSupervisor="isSupervisor=$event"
                        :valorTotalDespesas="valorTotalDespesas"
                        :valorTotalDespesasDebita_acerto="valorTotalDespesasDebita_acerto"
                        :aprovacaoParcial="aprovacaoParcial"
                        @recarregar="recarregar=$event"
                    />
                    <Despesas
                        ref="tabDespesas"
                        v-if="isUpdate && acertoDespesa != null && !recarregar"
                        v-show="abasAbertas['despesas'] && abas[abaSelecionada] == 'despesas'"
                        :acertoDespesa="acertoDespesa"
                        :rotaAninhada="rotaAninhada"
                        :parametrizacao="parametrizacao"
                        :cantEdit="cantEdit"
                        :isSupervisor="isSupervisor"
                        @valorTotalDespesas="valorTotalDespesas=$event"
                        @valorTotalDespesasDebita_acerto="valorTotalDespesasDebita_acerto=$event"
                        @aprovacaoParcial="aprovacaoParcial=$event"
                    />
                    <Adiantamentos
                        ref="tabAdiantamentos"
                        v-if="isUpdate && acertoDespesa != null && !recarregar"
                        v-show="abasAbertas['adiantamentos'] && abas[abaSelecionada] == 'adiantamentos'"
                        :acertoDespesa="acertoDespesa"
                        :parametrizacao="parametrizacao"
                        :cantEdit="cantEdit"
                        :isSupervisor="isSupervisor"
                        @valorTotalAdiantamentos="valorTotalAdiantamentos=$event"
                    />
                </div>
            </div>
            <div class="totalizadores" v-if="isUpdate">
                <div class="totalizador">
                    {{ $t("despesas") }}:
                    <strong>
                        {{ valorTotalDespesas | decimal(null, true) }}
                    </strong>
                </div>
                <div class="totalizador">
                    {{ $t("adiantamentos") }}:
                    <strong>
                        {{  valorTotalAdiantamentos | decimal(null, true) }}
                        </strong>
                </div>
                <div class="totalizador">
                    {{ $t("total-acerto") }}: 
                    <strong>
                        {{calcularTotalAcerto() | decimal(null, true)}}
                    </strong>
                </div>
            </div>
            <!-- Modal Imprimir acerto -->
            <b-modal
                :active.sync="isShowModalPrint"
                @close="isShowModalPrint = false"
            >
                <div class="bg modal-content">
                    <loader v-if="isLoadingPrint" />
                
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("selecione-recibo") }}
                            </h1>
                        </div>
                    </div>
                    <div class="columns mb-4">
                        <div class="column is-12">
                            <vss-select
                                v-if="!isLoadingPrint"
                                title="recibos"
                                v-model="modeloReciboSelected"
                                :options="modeloReciboSelect"
                                label="titulo"
                            />
                        </div>
                    </div>
                    <div class="columns ok">
                        <div class="form-buttons2">
                            <button class="delete-btn" @click="isShowModalPrint = false">
                                {{ $t("fechar") }}
                            </button>
                            <button @click="exportarAcerto()" class="save-btn">
                                {{ $t("imprimir") }}
                            </button>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    <router-view />
    </div>
</template>

<script>
import { mapState } from "vuex";
import AcertoDespesaService from "@/services/despesas/AcertoDespesaService";
import ConfigurarRecibosService from "@/services/despesas/ConfigurarRecibosService";

// Abas
import Geral from "@/components/despesas/acerto-despesa/abas/Geral.vue";
import Despesas from "@/components/despesas/acerto-despesa/abas/AcertoDespesaItem.vue";
import Adiantamentos from "@/components/despesas/acerto-despesa/abas/Adiantamentos.vue";

export default {
    components: {
        Geral,
        Despesas,
        Adiantamentos,
    },
    beforeRouteLeave(to, from, next) {
        if (from.name == "des-acerto-despesa-new" && to.name == "des-acerto-despesa-edit") {
            this.isUpdate = true;

            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("des-acerto-despesa-item")) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            next();
            if (to.query.abaSelecionada) {
                this.changeTab(this.abas.indexOf(to.query.abaSelecionada));
            }
        }
    },
    data() {
        return {
            rotaAninhada: false,
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("DES_ACERTO_DESPESA"),
            service: new AcertoDespesaService(this.$http, this.$router),
            serviceRecibo: new ConfigurarRecibosService(this.$http, this.$router),
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: ["geral", "despesas", "adiantamentos"],
            abasAbertas: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            isSaving: false,
            cantEdit: true,
            isSupervisor: false,
            acertoDespesa: null,
            parametrizacao: null,
            valorTotalDespesas: 0,
            valorTotalDespesasDebita_acerto: 0,
            valorTotalAdiantamentos: 0,
            aprovacaoParcial: 0,
            totalAcerto: 0,
            recarregar: false,
            modeloReciboSelect: [],
            modeloReciboSelected: null,
            isShowModalPrint: false,
            isLoadingPrint: false,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        this.rotaAninhada = (
            this.$route.name.includes("des-acerto-despesa-item"));

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "prestacao-contas",
            "des-acerto-despesa"
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "prestacao-contas" },
            });
        if (
            this.$route.params.id &&
            this.$route.params.name != "des-acerto-despesa-new"
        ) {
            this.isUpdate = true;
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    watch: {
        recarregar(val) {
            if(val) {
                setTimeout(() => this.recarregar = false, 300);
            }
        }
    },
    methods: {
        calcularTotalAcerto(){
            const totalDespesas = this.convertInteger(this.valorTotalDespesas);
            const totalAdiantamento = this.convertInteger(this.valorTotalAdiantamentos);

            return totalDespesas - totalAdiantamento
        },
        convertInteger(valor){
            return !valor || valor == " " ? 0 : Number(valor);
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[i]] = true;
            // muda a query
            if (this.$route.query) {
                if(
                    this.$route.query.abaSelecionada && 
                    this.$route.query.abaSelecionada == this.abas[i]
                ) {
                    return;
                }

                let query = {...this.$route.query};
                query.abaSelecionada = this.abas[i];
                if(this.abas[i] == 'despesas' && this.$route.query.idmotivo) {
                    query.idmotivo = this.$route.query.idmotivo;
                }
                this.$router.replace({'query': query});
            } else {
                this.$router.push({ abaSelecionada: this.abas[i] })
                    .catch((error) => {
                        if (
                            error.name !== 'NavigationDuplicated' &&
                            !error.message.includes('Avoided redundant navigation to current location')
                        ) console.log(error);
                    });
            }
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        redirectToPage() {
            let tempTela = "des-acerto-despesa-list";
            let tempAba = null;
            if (this.$route.query.tela == "tela") {
                tempTela = "des-tela-edit";
                tempAba = "geral";
            } 
            const route = {
                name: tempTela,
                params: { id: this.$route.query["id"] },
                query: {
                    abaSelecionada: tempAba
                },
            };
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
        buscarModelosRecibo() {
            this.serviceRecibo
                .findAllNoPagination('des_acerto_despesa')
                .then((r) => {
                    this.modeloReciboSelect = r.content;
                })
                .catch((e) => {
                    this.modeloReciboSelect = [];
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((r) => {
                    this.modeloReciboSelect.unshift({
                        id: 0,
                        idconfjasper: 0,
                        titulo: this.$t("nao-usar-modelo-recibo"),
                    });
                    //atribui como default o objeto acima que sempre ficara na posição 0 pois uso UNSHIFT para add na lista
                    this.modeloReciboSelected = this.modeloReciboSelect[0];
                    this.isShowModalPrint = true;
                });
        },
        exportarAcerto() {
            let uuid = this.acertoDespesa != null ? 
                this.acertoDespesa.uuid : null;
            let idconfjasper = this.modeloReciboSelected != null ? 
                this.modeloReciboSelected.idconfjasper : 0;

            this.service
                .exportarAcerto(idconfjasper, uuid)
                .then((value) => {
                    let filename = "acerto-" + uuid + ".pdf";

                    let blob = new Blob([value], { type: "application/pdf" });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", filename);
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(blob);
                    }, 100);
                })
                .catch((e) => {
                    console.error("Erro ao gerar pdf: ", { error: e });
                })
                .finally((r) => {
                    this.isLoadingPrint = false;
                    this.isShowModalPrint = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .page {
        position: relative;
        padding-left: 0;
        flex-grow: 1;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
    .totalizadores {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid $table-border;

        .totalizador {
            margin: 10px 14px;
            color: $darker-gray-color;
        }
    }
    .modal-content {
        padding: 20px;
        .form-buttons2 {
            top: 20px;
            display: flex;
            margin: 0 auto;

            .save-btn,
            .delete-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                color: $sovis-white;
                font-size: 12px;
                height: 47px;
                padding: 15px 40px;
                border: none;
                border-radius: 6px;
                font-weight: 600;
                margin-left: 20px !important;
                @include gradient-button();
            }

            .delete-btn {
                right: 225px;
                color: $darker-gray-color;
                @include exclude-button();
            }
        }
        .ok {
            margin: 0;
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
    .totalizadores {
        flex-direction: column;
        justify-content: center;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
